var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-4 col-sm-5 mt-4 p-2  font-weight-bold"},[_c('img',{staticStyle:{"max-width":"100px"},attrs:{"src":_vm.head}})]),_vm._v(" "),_c('baseCarousel',{attrs:{"books":_vm.books}}),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-5 p-2 font-weight-bold mb-3 button-link"},[_c('a',{staticClass:"no-underline text-white",attrs:{"href":""}},[_vm._v(_vm._s(_vm.base))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-643a725c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/overall_layouts/book-slider-logotop.vue
// module id = 611
// module chunks = 0